import {TextField} from "@mui/material";
import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import {FormInputProps} from "../../../types/formInputProps";


const FormInputTextDefaultValue = ({name, control, setValue, label, rules, sx, defaultValue}: FormInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({
                 field: {onChange, value},
                 fieldState: {error},
                 formState,
               }) => (
        <TextField
          /*InputProps={{
              style: {
                  paddingBottom: "10px"
              }
          }}*/
          id={`input-${name}`}
          helperText={error ? error.message : null}
          sx={sx}
          size="small"
          error={!!error}
          onChange={onChange}
          value={value ?? ''}
          fullWidth
          label={label}
          variant="outlined"
        />
      )}
      rules={{} && rules}
    />
  );
};
export default FormInputTextDefaultValue
